import { IFpayParams } from "@/api/apiRsp/IFWalletRsp";
import React, { useEffect } from "react";
import InputUI from "@/componentsUI/Input";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import CurrencyComponent from "@/components/currencyComponent";
import {
  AmountDivisorConversion,
  dealAmountAnyValid,
} from "@/Core/utils/currencyDealCenter";
import classNames from "classnames";
import ButtonUI from "@/componentsUI/Button";
import { getDefaultDepositGearIndex } from "./depositAmountDefaults";
import { getAccountDepositBonus, getLegacyDepositBonus, isFunBonus } from "./depositBonus";
import DepositBonusAmount, { DepositBonusSuffix } from "./DepositBonusAmount";
import "./index.less";

export interface DepositAmountProps {
  data: IFpayParams;
  onChange?: any;
  value?: any;
  readOnly?: boolean;
  currencyType?: any;
  serverCurrencyType?: any;
}

const DepositAmountButton = ({ gear, rebateRate, checked, onClick, currencyType }: any) => (
  <div className={classNames("deposit-amount-button", { checked })}>
    <ButtonUI onClick={onClick}>
      {dealAmountAnyValid(gear, 0, { currencyType })}
    </ButtonUI>
    {!!rebateRate && <label className="ratio">+{rebateRate}%</label>}
  </div>
);

const DepositAmount = (props: DepositAmountProps) => {
  const { readOnly, value, data, onChange, currencyType, serverCurrencyType } = props;
  const { t } = useTranslationPlus("Wallet");
  const checkedIndex = data?.custGears?.findIndex((item) =>
    value !== undefined && Number(value) === AmountDivisorConversion(item.gear, { currencyType, serverCurrencyType })
  ) ?? -1;
  const calculationCurrencyType = serverCurrencyType || currencyType;
  const accountBonus = getAccountDepositBonus(data, Number(value), calculationCurrencyType);
  const legacyBonus = getLegacyDepositBonus(data, Number(value), calculationCurrencyType);
  const inlineBonus = accountBonus?.amount ? accountBonus : legacyBonus.bonus;

  useEffect(() => {
    if (value === undefined && data && currencyType && data.custGears?.length > 0) {
      const defaultIndex = getDefaultDepositGearIndex(data.custGears);
      const defaultGear = data.custGears[defaultIndex].gear;
      handleChange(AmountDivisorConversion(defaultGear, { currencyType, serverCurrencyType }));
    }
  }, [data, currencyType, serverCurrencyType, value]);

  function handleChange(v: any) {
    if (v && v?.includes?.(",")) v = v.substring(0, v.indexOf(","));
    let amount = Number(v);
    if (isNaN(amount)) return;
    if (data?.decide === 2) {
      const maxValue = AmountDivisorConversion(data.max, { currencyType }) || 0;
      if (amount > maxValue) amount = maxValue;
    }
    onChange && onChange(amount);
  }

  return (
    <div className="deposit-amount">
      <InputUI
        readOnly={data?.decide === 1 || readOnly}
        onChange={handleChange}
        value={value}
        placeholder={t("Wallet.PlaceHolderInputAmount")}
        maxLength={10}
        prefix={<CurrencyComponent showUnit={false} currencyType={currencyType} />}
        suffix={inlineBonus?.amount && !isFunBonus(inlineBonus)
          ? <DepositBonusSuffix bonus={inlineBonus} />
          : null}
      />
      <DepositBonusAmount
        bonus={isFunBonus(accountBonus) ? accountBonus : undefined}
        label={t("Extra")}
      />
      <DepositBonusAmount {...legacyBonus} />
      <div className="amount-list has-input">
        {data?.custGears?.map((item, i) => (
          <DepositAmountButton
            key={i}
            gear={item.gear}
            rebateRate={item.rebateRate}
            checked={checkedIndex === i}
            currencyType={currencyType}
            onClick={() => {
              handleChange(dealAmountAnyValid(item.gear, 0, { currencyType }));
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default DepositAmount;
